/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement
 * Berichte verwalten
 *
 * The version of the OpenAPI document: 1.0.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NacharbeitsAuftrag
 */
export interface NacharbeitsAuftrag {
    /**
     * 
     * @type {string}
     * @memberof NacharbeitsAuftrag
     */
    beschreibung: string;
}

/**
 * Check if a given object implements the NacharbeitsAuftrag interface.
 */
export function instanceOfNacharbeitsAuftrag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "beschreibung" in value;

    return isInstance;
}

export function NacharbeitsAuftragFromJSON(json: any): NacharbeitsAuftrag {
    return NacharbeitsAuftragFromJSONTyped(json, false);
}

export function NacharbeitsAuftragFromJSONTyped(json: any, ignoreDiscriminator: boolean): NacharbeitsAuftrag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'beschreibung': json['Beschreibung'],
    };
}

export function NacharbeitsAuftragToJSON(value?: NacharbeitsAuftrag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Beschreibung': value.beschreibung,
    };
}

